import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react"
import SKland from "@skland/one-bridge"
import classNames from "classnames"
import { noop } from "lodash-es"
import { create } from "zustand"

import { useTranslation } from "@/locales"
import { getBase64Image } from "@/topic/rogue_4/pages/Game/utils/share"
import { GlobalContext } from "@/topic/rogue_5/context"
import { downloadImage, isMobile } from "@/utils/misc"
import { drawShareImage } from "../../../share"
import { useGameStore } from "../../../store"
import MainButton from "../../MainButton"

import downloadImg from "../../../../../../../assets/img/download.png"
import fb from "../../../../../../../assets/img/fb.png"
import twitter from "../../../../../../../assets/img/twitter.png"
import styles from "./index.module.less"

const useShareModalStore = create<{
    activate: (onExit?: () => void) => void
}>(() => ({
    activate: noop,
}))

export const useShareModal = () => useShareModalStore((state) => state.activate)

const ShareModal: React.FC<{
    className?: string
    style?: React.CSSProperties
}> = ({ className, style }) => {
    const {
        state: { user },
    } = useContext(GlobalContext)
    const [active, setActive] = useState(false)
    const exitHandlerRef = useRef<() => void>(noop)
    useEffect(() => {
        useShareModalStore.setState({
            activate: (onExit) => {
                setActive(true)
                exitHandlerRef.current = onExit || noop
            },
        })
    }, [])
    const [src, setSrc] = useState<string>("")
    // useEffect(() => {
    //     rowGameResult()
    // }, [])
    const { gameResult, gameType, gameRandomResult } = useGameStore()
    const closeHandler = useCallback(() => {
        setActive(false)
        exitHandlerRef.current()
    }, [])
    const { t } = useTranslation()
    useEffect(() => {
        if (gameResult && gameType && user) {
            const draw = async () => {
                const imageSrc = await drawShareImage(
                    {
                        type: gameType,
                        coins: gameResult.coins,
                        result: gameResult.result,
                        doctorName: user?.nickName || "",
                        uid: user?.uid || "",
                        randomResult: gameRandomResult,
                    },
                    true
                )
                setSrc(imageSrc)
            }
            // setTimeout(() => {
            draw()
            // }, 1000)
        }
    }, [gameResult, gameType, user])

    const share = async (type: "fb" | "twitter") => {
        switch (type) {
            case "twitter":
                // window.gtag('event', 'click_x')
                window.open(
                    "https://twitter.com/intent/tweet?url=" +
                        encodeURIComponent(`アークナイツ　統合戦略「歳の界園志異」特設サイト
#アークナイツ #統合戦略　＃歳の界園志異
${window.location.href}`),
                    "_blank"
                )
                break
            case "fb":
                // window.gtag('event', 'click_facebook')
                window.open(
                    "https://www.facebook.com/sharer/sharer.php?u=" +
                        window.location.href,
                    "_blank"
                )
                break
        }
    }
    return (
        <div
            className={classNames(
                styles.modalContainer,
                active && styles.active,
                className
            )}
            style={style}
            onClick={closeHandler}
        >
            <img
                className={styles.result}
                src={src}
                onClick={(e) => {
                    e.stopPropagation()
                }}
                onTouchStart={async () => {
                    const { img, base64 } = await getBase64Image(src)
                    SKland.shareImage({
                        html: img,
                        base64,
                    })
                }}
            />
            {/*{!isMobile() ? (*/}
            {/*    <MainButton*/}
            {/*        className={styles.button}*/}
            {/*        icon="temple"*/}
            {/*        type="blue"*/}
            {/*        text={t("game.button.save.cn")}*/}
            {/*        textEn={t("game.button.save.en")}*/}
            {/*        mark={null}*/}
            {/*        onClick={(e) => {*/}
            {/*            e.stopPropagation()*/}
            {/*            downloadImage(t("game.save.name"), src)*/}
            {/*        }}*/}
            {/*    />*/}
            {/*) : (*/}
            {/*    <div className={styles.text}>{t("game.share.mobile")}</div>*/}
            {/*)}*/}
            <div className={styles.flex}>
                <img
                    src={downloadImg}
                    className={styles.buttonIcon}
                    onClick={(e) => {
                        e.stopPropagation()
                        downloadImage(t("game.save.name"), src)
                    }}
                    alt=""
                />
                <img
                    src={twitter}
                    className={styles.buttonIcon}
                    onClick={(e) => {
                        e.stopPropagation()
                        share("twitter")
                    }}
                    alt=""
                />
            </div>
        </div>
    )
}

export default ShareModal
